/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import Button, { Icons } from "../buttons/Button";
import { SIDEPANEL_GENERAL_TRANSLATIONS } from "../../translations/util";

interface IProps {
  panelName: string;
  handleUpdate?: any;
  hasEditPermission?: boolean;
  isFormInvalid: any;
  isEditing: boolean;
  setIsEditing: any;
  revertToInitialState: any;
  loading: boolean;
}

const EditGroupFormButtons = ({
  panelName,
  handleUpdate,
  hasEditPermission,
  isFormInvalid,
  isEditing,
  setIsEditing,
  revertToInitialState,
  loading,
}: IProps) => {
  return (
    <div className="tab-header">
      <h5 data-cy={`${panelName.replace(" ", "")}-subHeading`}>
        {" "}
        {panelName}{" "}
      </h5>
      {!isEditing ? (
        <div>
          <Button
            className="w-sm mr-2"
            kind="tertiary"
            icon={Icons.Edit}
            disabled={!hasEditPermission}
            label={SIDEPANEL_GENERAL_TRANSLATIONS.buttonLabels.edit}
            onClick={() => setIsEditing(true)}
            dataCy={`${panelName.replace(" ", "")}Edit-`}
          />
        </div>
      ) : (
        <div className="tab-header-buttons">
          <Button
            className="w-sm mr-2"
            type="button"
            kind="tertiary"
            disabled={false}
            label={SIDEPANEL_GENERAL_TRANSLATIONS.buttonLabels.cancel}
            onClick={() => {
              revertToInitialState();
            }}
            dataCy={`${panelName.replace(" ", "")}Cancel-`}
          />
          <Button
            className="w-sm"
            type="button"
            disabled={isFormInvalid}
            onClick={() => handleUpdate()}
            loading={loading}
            label={SIDEPANEL_GENERAL_TRANSLATIONS.buttonLabels.save}
            dataCy={`${panelName.replace(" ", "")}Save-`}
          />
        </div>
      )}
    </div>
  );
};

export default EditGroupFormButtons;
